import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { employeeHourActions } from 'store/aggregated/employeeHour';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// On-demand fetch of aggregated employee-hour rows for a specific set of
// dates and replaces the `employeeHour` domain with the result. Triggered
// by the Time page when the user picks dates in the calendar modal — not
// part of the authenticated-layout boot fan-out.
//
// Gated on `JwtFeature.Activity` because it hits the same endpoint as
// `initializeAggregatedActivities` (just at Employee resolution).
export function* loadEmployeeHours(args: { dates: Time.Date[] }) {
  const { dates } = args;

  function* work(tenantId: string) {
    const { employeeHourDomain }: SagaReturnType<typeof api.getEmployeeHours> =
      yield call(api.getEmployeeHours, { tenantId, dates });

    yield put(employeeHourActions.setDomain(employeeHourDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Activity);
}
